export const CREDITS = 'Credits'